module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6kjwRUZGidPqx1TgRhQ3N8-9be118164564ae9a0a2135a3c1950fe3.jpg";